export default "__VITE_ASSET__kQ5vkvt9__"